import { take, type Observable } from "rxjs";
import type { DynamicComponentService, AlertType } from "@shared/components/atomics/body-loading/dynamic-component-service.service";
import { PersonalizedAlertButton } from "@shared/components/atomics/body-loading/personalized-button";

// Binding del servicio de componente dinámico a una función para abrir una alerta
export const openAlertFn = (dynamicComponentService: DynamicComponentService, messageField: 'message' | 'htmlContent') =>
  (
    title: string,
    message: string,
    alertType: AlertType,
    autohide: boolean,
    animate = true,
    showButtons = true,
    onAlertCloseCallback?: Function,
  ): Observable<boolean | { result: boolean, text: string }> =>
    dynamicComponentService.showAlert({
      title,
      alertType,
      autohide,
      animate,
      showButtons,
      [messageField]: message,
    }, onAlertCloseCallback);

// Misma función; realizando unsubscribe mediante una promesa
export const openUnsubAlertFn = (dynamicComponentService: DynamicComponentService, messageField: 'message' | 'htmlContent') =>
  (
    title: string,
    message: string,
    alertType: AlertType,
    autohide: boolean,
    animate = true,
    showButtons = true,
    onAlertCloseCallback?: Function,
  ) => new Promise<boolean | { result: boolean, text: string }>( resolve => {
    let resolved: boolean = false;
    const alert = dynamicComponentService.showAlert({
      title,
      alertType,
      autohide,
      animate,
      showButtons,
      [messageField]: message,
    },
    () => {
      alert.unsubscribe();
      if (!resolved) {
        resolve(false);
        resolved = true;
      }
      onAlertCloseCallback && onAlertCloseCallback();
    }).pipe(take(1)).subscribe({
      next: value => {
        resolved = true;
        resolve(value)
      },
      error: () => {
        resolved = true;
        resolve(false);
      },
    });
  });
// Alerta con botones personalizados
export const openAlertPersonalizedButtons = (
  dynamicComponentService: DynamicComponentService,
  messageField: 'message' | 'htmlContent') =>
  (
    title: string,
    message: string,
    alertType: AlertType,
    autohide: boolean,
    animate = true,
    showButtons = true,
    textButtons: { textSuccessButton: string, textCancelButton: string } = { textSuccessButton: 'Si', textCancelButton: 'No' },
    onAlertCloseCallback?: Function,
  ): Observable<boolean | { result: boolean, text: string }> =>
    dynamicComponentService.showAlert({
      title,
      alertType,
      autohide,
      animate,
      showButtons,
      [messageField]: message,
      ...textButtons
    }, onAlertCloseCallback);
// Alerta con botones personalizados
export const openAlertButtonsArray = (
  dynamicComponentService: DynamicComponentService,
  messageField: 'message' | 'htmlContent',
) =>
  (
    title: string,
    message: string,
    alertType: AlertType,
    autohide: boolean,
    animate = true,
    showButtons = true,
    onAlertCloseCallback?: Function,
    personalizedButtons: PersonalizedAlertButton[] = [],
  ): Observable<boolean | { result: boolean, text: string }> =>
    dynamicComponentService.showAlert({
      title,
      alertType,
      autohide,
      animate,
      showButtons,
      [messageField]: message,
      personalizedButtons,
      width: '630px',
    }, onAlertCloseCallback);
